import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  UrlField,
  Pagination,
  WrapperField,
  DeleteWithConfirmButton,
} from "react-admin";

import { FILTER_LIMITS } from "@/constants/filters";
import { MODULE_NAMES } from "@/constants/modules";
import { DateFieldWithStandardFormat } from "@/fields/DateFieldWithStandardFormat";
import { ReferenceField } from "@/fields/ReferenceField";

import { LandingDomainDeleteAfterButton } from "./LandingDomainDeleteAfterButton";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const LandingDomainsList = () => {
  return (
    <List
      actions={<ListActions />}
      pagination={<Pagination rowsPerPageOptions={FILTER_LIMITS} />}
      storeKey={false}
    >
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" sortable={false} />
        <UrlField source="url" sortable={false} />
        <ReferenceField
          source="region.id"
          module={MODULE_NAMES.LANDING_REGIONS}
          label="Region"
        />
        <WrapperField sortable={false} textAlign="right">
          <DeleteWithConfirmButton label="Delete Now" />
          <LandingDomainDeleteAfterButton />
        </WrapperField>
        <DateFieldWithStandardFormat source="expiresAt" sortable={false} />
      </DatagridConfigurable>
    </List>
  );
};
